import script from "./PaywallLists.vue?vue&type=script&setup=true&lang=js"
export * from "./PaywallLists.vue?vue&type=script&setup=true&lang=js"

import "./PaywallLists.vue?vue&type=style&index=0&id=fffae9e4&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fffae9e4"]])

export default __exports__